import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import ButtonTooltip from '../../../components/Inputs/ButtonTooltip';
import { api } from '../../../components/api/api';
import { Pergunta, Alert, AlertErro } from '../../../util/Alertas';
import { exportCSV } from '../../../util/Excel';
import { Col, Modal, Row } from 'react-bootstrap';

import { TiPlus, TiMinus, TiTrash, TiPencil } from "react-icons/ti";
import { FaDownload, FaHistory } from "react-icons/fa";

import ModalDepositoEstoqueQuantidade from './ModalDepositoEstoqueQuantidade';
import ModalLogDepositoEstoque from './ModalLogDepositoEstoque';

const DepositoEstoque = forwardRef((props, ref) => {
    const estoqueRef = useRef();
    const logRef = useRef();
    const [estoques, setEstoques] = React.useState([]);
    const [name, setName] = useState('');
    const [show, setShow] = useState(false);
    const [depositoId, setDepositoId] = useState(0);

    // Função que você quer expor para o pai
    const openModal = (depositoId) => {
        api.get('/api/DepositoEstoque/' + depositoId, res => {
            setEstoques(res.data);
            setShow(true)
            setDepositoId(depositoId)
        }, err => {
            AlertErro(err)
        })
    };

    // Aqui você expõe funções para o PAI acessar
    useImperativeHandle(ref, () => ({
        openModal
    }));

    const onDelete = async (id) => {
        if (await Pergunta('Deseja Realmente EXCLUIR essa matéria prima?')) {
            api.delete(`/api/DepositoEstoque/${id}`, res => {
                setEstoques(res.data);
                Alert("Estoque excluido com sucesso!");
            }, err => AlertErro(err))
        }
    }

    const onClose = () => {
        setDepositoId(0)
        setEstoques([])
        setName('')
        setShow(false)
    }

    return (
        <Modal show={show} size='xl' centered >
            <Modal.Header>
                <h2>Estoque: #{depositoId}</h2>
            </Modal.Header>
            <Modal.Body>

                <ModalDepositoEstoqueQuantidade
                    ref={estoqueRef}
                    setEstoques={setEstoques}
                />
                <ModalLogDepositoEstoque
                    ref={logRef}
                />
                <small>Filtro:</small>
                <Row>
                    <Col md={8}>
                        <label htmlFor="">Buscar por Nome</label>
                        <input className='form-control' value={name} onChange={e => setName(e.target.value)} type="text" name="" id="" />
                    </Col>
                    <Col style={{ marginTop: '20px' }}>
                        <button onClick={e => exportCSV(estoques.filter(x => x.nome.toUpperCase().includes(name.toUpperCase())), 'DepositoEstoque.csv')} className='btn btn-success'>Download <FaDownload size={23} color='#fff' /></button>
                    </Col>
                </Row>
                <br />
                <button onClick={e => estoqueRef.current.novo(depositoId)} className='btn btn-primary'>Adicionar Nova Matéria prima <TiPlus size={23} color='#fff' /></button>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Quantidade</th>
                            <th>Valor Un.</th>
                            <th>Entrada</th>
                            <th>Saída</th>
                            <th>Excluir</th>
                            <th>Logs</th>
                        </tr>
                    </thead>
                    <tbody>
                        {estoques.filter(x => x.nome.toUpperCase().includes(name.toUpperCase())).map(x => (<tr key={x.id}>
                            <td data-label="Nome">{x.nome}</td>
                            <td data-label="Quantidade">{x.quantidade}</td>
                            <td data-label="Valor Un">R$ {x.valorUn.toFixed(2).replaceAll('.', ',')}</td>
                            <td data-label="Entrada">
                                <ButtonTooltip
                                    text={"Informar Entrada"}
                                    textButton={<TiPlus size={23} color='#fff' />}
                                    className='btn btn-success'
                                    top={true}
                                    onClick={() => estoqueRef.current.edit(x, true, false)}
                                />
                            </td>
                            <td data-label="Saída">
                                <ButtonTooltip
                                    text={"Informar Saída"}
                                    textButton={<TiMinus size={23} color='#fff' />}
                                    className='btn btn-success'
                                    top={true}
                                    onClick={() => estoqueRef.current.edit(x, false, true)}
                                />
                            </td>
                            <td data-label="Excluir">
                                <ButtonTooltip
                                    text={"Excluir Materia Prima"}
                                    textButton={<TiTrash size={23} color='#fff' />}
                                    className='btn btn-danger'
                                    top={true}
                                    onClick={() => onDelete(x.id)}
                                />
                            </td>
                            <td data-label="Logs">
                                <ButtonTooltip
                                    text={"Ver Logs Materia Prima"}
                                    textButton={<FaHistory size={23} color='#fff' />}
                                    className='btn btn-danger'
                                    top={true}
                                    onClick={() => logRef.current.open(x.id)}
                                />
                            </td>
                        </tr>))}
                        {estoques.length === 0 && <tr>
                            <td colSpan="10"><span>Não foi encontrado nenhum estoque...</span></td>
                        </tr>}
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={onClose} className='btn btn-danger'>Fechar</button>
            </Modal.Footer>
        </Modal>
    );
});

export default DepositoEstoque;
